/* eslint-disable radix */
/* eslint-disable react/require-default-props */
/* eslint-disable no-lone-blocks */
import React from 'react'
import PropTypes from 'prop-types'
import {
  Button, Card, Typography,
} from '@material-ui/core'
import clsx from 'clsx'
import Tooltip from '@material-ui/core/Tooltip'
import useStyles from './cardPackage-jss'

const CardPackage = ({
  index, title, description, price, onPackageChange,
}) => {
  const classes = useStyles()

  return (
    <Card className={clsx(classes.card, classes.bgPremium)}>
      <div className={classes.row}>
        <div className={clsx(classes.col, classes.paddingBox)}>
          <Typography
            variant="h1"
            className={classes.title}
            color="primary"
            gutterBottom
          >
            {title}
          </Typography>
          <Tooltip title={description} placement="left">
            <Typography
              variant="h1"
              className={classes.description}
              color="primary"
            >
              {description}
            </Typography>
          </Tooltip>
          <Typography
            variant="h1"
            className={classes.price}
            color="secondary"
            gutterBottom
          >
            {parseInt(price?.replace(/\D/g, '')) > 0 ? price : ''}
          </Typography>
        </div>
      </div>
      <Button
        className={classes.button}
        color="primary"
        variant="contained"
        onClick={() => onPackageChange(index)}
      >
        Pilih
      </Button>
    </Card>
  )
}

CardPackage.propTypes = {
  index: PropTypes.any.isRequired,
  description: PropTypes.any,
  price: PropTypes.any.isRequired,
  title: PropTypes.any.isRequired,
  onPackageChange: PropTypes.func.isRequired,
}

export default CardPackage
